import React, { useEffect, useRef, useState } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css'
import './SecTwo.scss'
import { FiArrowRight } from 'react-icons/fi'
import building from './../../assets/building.svg'
import leftB from './../../assets/LP/leftB.svg'
import midB from './../../assets/LP/midB.svg'
import rightB from './../../assets/LP/rightB.svg'
import allBuilding from './../../assets/LP/allBuilding.png'
import b1 from './../../assets/LP/building/1.png'
import b2 from './../../assets/LP/building/2.png'
import b3 from './../../assets/LP/building/3.png'
import b4 from './../../assets/LP/building/4.png'
import b5 from './../../assets/LP/building/5.png'
import b6 from './../../assets/LP/building/6.png'
import b7 from './../../assets/LP/building/7.png'
import b8 from './../../assets/LP/building/8.png'
import b9 from './../../assets/LP/building/9.png'
import mbuilding from './../../assets/LP/mbuilding.png'
import s1 from './../../assets/LP/lpSliderImg/i1.png'
import s2 from './../../assets/LP/lpSliderImg/i2.png'
import s3 from './../../assets/LP/lpSliderImg/i3.png'
import s4 from './../../assets/LP/lpSliderImg/i4.png'

import CountUp, { useCountUp } from 'react-countup'

import { TweenMax, TimelineLite, Power3, Power0 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import gsap from 'gsap'

import Slider from 'react-slick'
gsap.registerPlugin(ScrollTrigger)

export default function SecTwo() {
  let tl = new TimelineLite({ delay: 0.2 })

  useEffect(() => {
    gsap.to('.b1Img', {
      duration: 1,
      y: '-375px',
      delay: 1,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })
    gsap.to('.b2Img', {
      duration: 1,
      y: '-490px',
      delay: 1.4,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })
    gsap.to('.b3Img', {
      duration: 1,
      y: '-390px',
      delay: 1.9,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.b4Img', {
      duration: 1,
      y: '-490px',
      delay: 2.2,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.b5Img', {
      duration: 1,
      y: '-500px',
      delay: 2.4,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })
    gsap.to('.b6Img', {
      duration: 1,
      y: '-490px',
      delay: 2.2,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })
    gsap.to('.b7Img', {
      duration: 1,
      y: '-418px',
      delay: 1.9,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.b8Img', {
      duration: 1,
      y: '-458px',
      delay: 1.4,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })

    gsap.to('.b9Img', {
      duration: 1,
      y: '-398px',
      delay: 1,
      ease: Power0,
      scrollTrigger: {
        trigger: '.imgCONST',
        // markers: true,
        start: 'top 60%',
        end: 'bottom 10%',
        // toggleActions: 'play none none reverse',
        toggleActions: 'restart complete reverse reset',
        //options: play, pause, resume, reset, restart, complete, reverse,none
      },
    })
  })
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  }

  const [sliderData, setSliderData] = useState([
    {
      h1: 'Eliminate Intermediaries',
      h2:
        'Smart contracts let you collect and disburse payment without intermediaries by engaging in direct transactions with Owners.',
    },
    {
      h1: 'Securities',
      h2:
        'Enjoy seamless and hassle-free transactions between Owner Operators and Investors by setting up deals on smart contracts.',
    },
    {
      h1: 'On-chain Settlement',
      h2:
        'Get rid of traditional time-consuming deals and contracts and enjoy the benefit of lightning fast automated settlements using smart contracts. ',
    },
    {
      h1: 'Anti Fraud Technology',
      h2:
        'Eliminate the risk of internal fraud and conflicts in workflows by setting up deals in smart contracts while maintaining an immutable transactional process.',
    },
  ])
  const [activeSliderData, setActiveSliderData] = useState(sliderData[0])

  const [activeBox, setActiveBox] = useState(0)
  return (
    <div className="section2-New">
      <div className="left">
        <div className="sliderConBOX">
          <div className="svgLine1 svgline">
            <svg
              width="358"
              height="2"
              viewBox="0 0 358 2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M358 1L9.98419e-06 0.999969"
                stroke="url(#paint0_linear_5111_13257)"
                strokeWidth="2"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_5111_13257"
                  x1="358"
                  y1="1"
                  x2="-0.000578339"
                  y2="0.306815"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#219EBC" />
                  <stop offset="1" stopColor="#219EBC" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="svgLine2 svgline">
            <svg
              width="2"
              height="117"
              viewBox="0 0 2 117"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 117L1.00001 1.91739e-06"
                stroke="url(#paint0_linear_5111_13259)"
                strokeWidth="2"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_5111_13259"
                  x1="1"
                  y1="117"
                  x2="1.22438"
                  y2="-0.0014875"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#219EBC" />
                  <stop offset="1" stopColor="#219EBC" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="svgLine3 svgline">
            <svg
              width="362"
              height="2"
              viewBox="0 0 362 2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M0 1L362 1"
                stroke="url(#paint0_linear_5111_13256)"
                strokeWidth="2"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_5111_13256"
                  x1="0"
                  y1="1"
                  x2="362.001"
                  y2="1.70873"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#219EBC" />
                  <stop offset="1" stopColor="#219EBC" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>
          <div className="svgLine4 svgline">
            <svg
              width="2"
              height="155"
              viewBox="0 0 2 155"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 0L0.999993 155"
                stroke="url(#paint0_linear_5111_13258)"
                strokeWidth="2"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_5111_13258"
                  x1="1"
                  y1="0"
                  x2="0.606195"
                  y2="155.002"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#219EBC" />
                  <stop offset="1" stopColor="#219EBC" stopOpacity="0" />
                </linearGradient>
              </defs>
            </svg>
          </div>

          <div
            onMouseEnter={() => {
              setActiveSliderData(sliderData[0])
              setActiveBox(0)
            }}
            className={'item1 boxI ' + (activeBox === 0 ? ' active ' : '')}
          >
            <BoxItem
              h1="01"
              h2="eliminate intermediaries"
              svg={
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_5111_13279)">
                    <g clip-path="url(#clip1_5111_13279)">
                      <path
                        d="M27.0044 23.3146C31.7101 23.3146 35.4307 19.3928 35.4307 14.6729C35.4307 9.95305 31.7101 6.03125 27.0044 6.03125C22.2988 6.03125 18.5781 9.95305 18.5781 14.6729C18.5781 19.3928 22.2988 23.3146 27.0044 23.3146Z"
                        stroke="white"
                        strokeWidth="3.5"
                      />
                      <path
                        d="M40.9539 38.9999C40.9539 35.6312 34.7073 28.3867 27.001 28.3867C19.2947 28.3867 13.0469 35.6312 13.0469 38.9999"
                        stroke="white"
                        strokeWidth="3.5"
                      />
                      <path
                        d="M1.88281 16.0664L45.8048 33.0628"
                        stroke="#002133"
                        strokeWidth="6.5"
                      />
                      <path
                        d="M5.57812 17.6641L49.5002 34.6604"
                        stroke="white"
                        strokeWidth="3.5"
                      />
                    </g>
                  </g>
                  <defs>
                    <clipPath id="clip0_5111_13279">
                      <rect width="48" height="48" fill="white" />
                    </clipPath>
                    <clipPath id="clip1_5111_13279">
                      <rect
                        width="48"
                        height="48"
                        fill="white"
                        transform="translate(3 -1)"
                      />
                    </clipPath>
                  </defs>
                </svg>
              }
            />
          </div>
          <div
            onMouseEnter={() => {
              setActiveSliderData(sliderData[1])
              setActiveBox(1)
            }}
            className={'item2  boxI' + (activeBox === 1 ? ' active ' : '')}
          >
            <BoxItem
              h1="02"
              h2="Settlements"
              svg={
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M19.4583 19.5421L23.4578 16.2462L23.4643 16.2408L23.4643 16.2408L24.6362 15.2916L25.4227 14.6546L26.0502 15.4487L26.985 16.6317L33.3573 24.5541L33.3872 24.5911L33.4133 24.6309L33.4625 24.7055C33.7922 25.0689 34.0582 25.4544 34.2767 25.853L37.8884 24.0058L37.8921 24.0039L37.9858 23.9564L38.1988 23.8486H38.365L41 22.9473V14.8997C38.4411 14.6427 36.3029 14.0791 34.6937 13.4388L19.4583 19.5421ZM19.4583 19.5421C18.9502 19.8912 18.5546 19.9771 18.2192 19.9677C18.0665 19.9635 17.9091 19.939 17.7411 19.8947L19.4583 19.5421ZM32.9016 34.1265L32.9112 34.1198L33.0438 34.0303L33.1261 33.9747L33.1959 33.9041L33.2867 33.8121C33.2872 33.8116 33.2877 33.8111 33.2881 33.8107C34.0505 33.0446 34.4659 32.1502 34.7333 31.2838L40.047 28.572L44.2835 27.1267L45.3066 26.7971L46 26.5737V25.8452V11.0855V10.0855H45H43.5C40.41 10.0855 38.2235 9.41278 36.5096 8.7323C36.093 8.56688 35.7127 8.39075 35.3378 8.2118C35.2617 8.17547 35.1848 8.13854 35.1074 8.10135C34.8128 7.95984 34.5104 7.81458 34.2129 7.68475C33.4385 7.34688 32.6032 7.06988 31.5677 7.04833L31.5663 7.04831C31.2857 7.04284 31.0059 7.03542 30.7274 7.02804C30.1307 7.01222 29.5402 6.99656 28.9616 7.00068C28.1043 7.0068 27.1748 7.04874 26.1752 7.32042C25.3703 7.5392 24.5695 7.86576 23.7453 8.35174C22.7396 7.78555 21.6579 7.28526 20.5605 7.15062C19.4198 7.00769 18.3268 7.04086 17.2328 7.07406C16.9663 7.08215 16.6997 7.09025 16.4324 7.09579L16.4321 7.0958C15.4026 7.11744 14.5661 7.39908 13.7931 7.73691C13.4554 7.88451 13.1637 8.02468 12.8772 8.16238C12.4503 8.3675 12.0349 8.56713 11.4957 8.77766C9.78766 9.44452 7.60397 10.0855 4.5 10.0855H3H2V11.0855V25.7029V26.3175L2.54835 26.5951L3.3921 27.0222L3.39208 27.0222L3.39822 27.0253L5.98991 28.315L15.7048 39.275L15.7227 39.2952L15.7416 39.3144L15.7885 39.3619L15.7922 39.3656C17.1942 40.7703 19.0422 41.0726 20.5418 40.9864C22.0388 40.9003 23.4597 40.4571 24.6156 39.7495C25.7513 39.0559 27.8372 37.6393 29.6169 36.4125C30.5119 35.7955 31.3372 35.2211 31.9388 34.801C32.2396 34.5909 32.4845 34.4193 32.6543 34.3001L32.8504 34.1625L32.9016 34.1265ZM18.5832 12.0853C18.8358 12.0801 19.0606 12.0787 19.2655 12.0828L11.923 18.2424L10.6605 19.2839L9.83395 19.9657L10.5712 20.7433L11.6914 21.9247L11.6916 21.925L11.7057 21.94C11.7173 21.9524 11.7332 21.9691 11.7532 21.9897C11.7932 22.031 11.8497 22.0882 11.9219 22.1581C12.0661 22.2978 12.2738 22.4892 12.5372 22.7068C13.0613 23.1397 13.8211 23.6886 14.7549 24.1366C16.6257 25.0341 19.6381 25.5998 22.3729 23.6728L22.4457 23.6214L22.5083 23.558L22.5679 23.4977L24.6549 21.7596L29.48 27.7626L29.5499 27.9042L29.6635 28.0192L29.7104 28.0667L29.7104 28.0667L29.7146 28.0709C30.062 28.4185 30.2068 28.8897 30.1399 29.3484L29.0273 27.8196L28.4342 27.0047L27.624 27.6041L25.1865 29.4076L24.3844 30.001L24.976 30.8044L26.2914 32.5909C26.2787 32.5999 26.2661 32.6089 26.2535 32.6179C26.2222 32.6402 26.1911 32.6625 26.16 32.6847C26.096 32.7303 26.0319 32.7759 25.9665 32.8223L24.5256 30.8546L23.9318 30.0438L23.124 30.6415L20.6865 32.445L19.8844 33.0384L20.476 33.8418L21.7516 35.5743C21.3647 35.7481 20.7925 35.9224 20.2875 35.9522C19.993 35.968 19.7564 35.9402 19.5862 35.8976C19.4654 35.8673 19.3969 35.8346 19.367 35.8181L9.39114 24.6324L9.22212 24.4185L9.08561 24.2457L8.88915 24.1463L7 23.1899V14.9019C9.54625 14.6538 11.6948 14.1128 13.2991 13.4891C14.2125 13.1348 15.0081 12.8085 15.6158 12.5593C15.6817 12.5323 15.7454 12.5062 15.8068 12.481C16.124 12.3511 16.3713 12.2505 16.5493 12.1821C16.6084 12.1594 16.6545 12.1423 16.6893 12.1299C16.9513 12.1238 17.2009 12.1177 17.4386 12.1119C17.8561 12.1017 18.2368 12.0924 18.5832 12.0853ZM16.7675 12.1046C16.767 12.1049 16.7602 12.107 16.7481 12.11C16.7618 12.1057 16.7679 12.1042 16.7675 12.1046Z"
                    fill="white"
                    stroke="#002133"
                    strokeWidth="2"
                  />
                </svg>
              }
            />
          </div>
          <div
            onMouseEnter={() => {
              setActiveSliderData(sliderData[2])
              setActiveBox(2)
            }}
            className={'item3 boxI ' + (activeBox === 2 ? ' active ' : '')}
          >
            {' '}
            <BoxItem
              h1="03"
              h2="Instant Settlement"
              svg={
                <svg
                  width="43"
                  height="43"
                  viewBox="0 0 43 43"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_5111_13274)">
                    <path
                      d="M21.825 21.9125V22.1972L22.0699 22.3425L29.0596 26.4898L28.3441 27.6633L20.35 22.8669V13.75H21.825V21.9125ZM5.5 21.5C5.5 12.6675 12.6523 5.5 21.4835 5.5C30.3322 5.5 37.5 12.6685 37.5 21.5C37.5 30.3315 30.3322 37.5 21.4835 37.5C12.6523 37.5 5.5 30.3325 5.5 21.5ZM7.8 21.5C7.8 29.0691 13.9309 35.2 21.5 35.2C29.0691 35.2 35.2 29.0691 35.2 21.5C35.2 13.9309 29.0691 7.8 21.5 7.8C13.9309 7.8 7.8 13.9309 7.8 21.5Z"
                      fill="white"
                      stroke="white"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_5111_13274">
                      <rect width="43" height="43" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              }
            />
          </div>
          <div
            onMouseEnter={() => {
              setActiveSliderData(sliderData[3])
              setActiveBox(3)
            }}
            className={'item4 boxI' + (activeBox === 3 ? ' active ' : '')}
          >
            <BoxItem
              h1="04"
              h2="Secure Settlements"
              svg={
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 48 48"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M38.1622 11.2178C38.1636 11.2215 38.1648 11.2248 38.1658 11.2277V22.9932V22.9933C38.1665 26.1118 37.3292 29.1744 35.7397 31.8665C34.1502 34.5586 31.8658 36.7831 29.121 38.3114L29.1208 38.3115L24 41.1691L18.8792 38.3115L18.879 38.3114C16.1342 36.7831 13.8498 34.5586 12.2603 31.8665C10.6708 29.1744 9.83346 26.1118 9.83421 22.9933V22.9932V11.2064L9.83433 11.2041C9.83455 11.2008 9.83509 11.1942 9.83637 11.1847C9.83892 11.1658 9.84443 11.1349 9.8563 11.0938C9.87996 11.0117 9.92928 10.8875 10.0323 10.7343C10.2383 10.4283 10.6632 10.0007 11.5403 9.56623C13.2986 8.69531 16.8497 7.80909 24 7.80909C30.7003 7.80909 34.2543 8.69457 36.1274 9.56777C37.0627 10.0038 37.5762 10.4355 37.8539 10.7499C37.9927 10.9071 38.0732 11.0356 38.1182 11.1217C38.1407 11.1648 38.1544 11.1974 38.1622 11.2178ZM6.85 22.9932L6.85 22.9933L41 11.2045C41.0002 10.9864 40.9732 10.7691 40.9195 10.5575L41.0649 10.5208C41.0649 10.5207 41.0649 10.5207 41.0649 10.5206C40.79 9.43168 39.8987 8.00987 37.3885 6.86451C34.8837 5.72167 30.7602 4.85 24 4.85C17.6386 4.85 12.9909 5.5406 10.2064 6.92198C8.66385 7.68293 7.822 8.59143 7.36713 9.39567C6.91294 10.1987 6.85 10.8881 6.85 11.2045L6.85 22.9932ZM41.15 22.9932V11.2047L22.61 43.785L22.6838 43.6544L22.6109 43.7855L22.6107 43.7854C23.0341 44.0245 23.5129 44.15 24 44.15C24.4871 44.15 24.9659 44.0245 25.3893 43.7854C25.3895 43.7852 25.3897 43.7851 25.39 43.785L30.583 40.8959L30.5832 40.8958C33.7873 39.1069 36.4543 36.5065 38.311 33.3609C40.1677 30.2153 41.1475 26.6374 41.15 22.9933V22.9932ZM23.1049 29.525L23.1059 29.525C23.5002 29.5234 23.8783 29.368 24.1581 29.0918L24.1583 29.0916L33.9986 19.3434C34.1444 19.2084 34.2614 19.0456 34.3427 18.8649C34.4243 18.6833 34.4683 18.4873 34.4718 18.2884C34.4754 18.0895 34.4384 17.8921 34.3633 17.7078C34.2881 17.5235 34.1763 17.356 34.0345 17.2155C33.8928 17.0751 33.724 16.9646 33.5383 16.8903C33.3526 16.816 33.1538 16.7795 32.9536 16.783C32.7535 16.7865 32.5561 16.83 32.3732 16.9107C32.1911 16.9911 32.027 17.1067 31.8907 17.2511L23.1044 25.9551L17.8952 20.7947L17.8953 20.7947L17.8914 20.7911C17.6084 20.5299 17.2345 20.388 16.8484 20.3947C16.4622 20.4015 16.0936 20.5565 15.8201 20.8274C15.5466 21.0984 15.3897 21.4642 15.3828 21.848C15.376 22.2317 15.5198 22.6029 15.7835 22.8833L15.7835 22.8833L15.7872 22.8871L22.0504 29.0916L22.0506 29.0918C22.3309 29.3685 22.7098 29.5239 23.1049 29.525Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="0.3"
                  />
                </svg>
              }
            />
          </div>

          <div className="smidCon">
            <h1>{activeSliderData.h1}</h1>
            <h2>{activeSliderData.h2}</h2>
          </div>
        </div>
      </div>
      {/* <div className="bMV">
          <img className="bgBuildingMob" src={mbuilding} alt="" />
          <div className="mainSi">
            <Slider {...settings}>
              <div className="SlsCon">
                <img className="sImg" src={s1} alt="" />
              </div>
              <div className="SlsCon">
                <img  src={s2} alt="" />
              </div>
              <div className="SlsCon">
                <img  src={s3} alt="" />
              </div>
              <div className="SlsCon">
                <img src={s4} alt="" />
              </div>
            </Slider>
          </div>
        </div> */}
      <div data-aos="fade-right" className="left">
        <div className="leftcon"></div>
      </div>
      <div className="right">
        <div className="rt">
          <h1>Features</h1>
          <h2>
            Our distributed ledger network allows investors to trade newly
            released shares listed on Lilypads Securities.
          </h2>
        </div>
        <div className="rb">
          <div
            style={{ overflow: 'hidden' }}
            className="imgConBuildingN imgCONST"
          >
            <img className="b1Img" src={b1} alt="" />
            <img className="b2Img" src={b2} alt="" />
            <img className="b3Img" src={b3} alt="" />
            <img className="b4Img" src={b4} alt="" />
            <img className="b5Img" src={b5} alt="" />
            <img className="b6Img" src={b6} alt="" />
            <img className="b7Img" src={b7} alt="" />
            <img className="b8Img" src={b8} alt="" />
            <img className="b9Img" src={b9} alt="" />
            {/* <img data-aos="fade-left" src={allBuilding} alt="allBuilding" /> */}
          </div>
        </div>
      </div>

      {/*
      <div className="aboutus">
        <div className="imgcon">

        <img className="aboutBuildingBig" src={aboutBuildingBig} alt="aboutBuildingBig" />
        </div>


      </div> */}
    </div>
  )
}

function BoxItem({ h1, h2, svg }) {
  return (
    <div className="BoxItem">
      <h1>{h1}</h1>
      <div className="circleWrapper">
        <div className="circle">{svg}</div>
      </div>
      <h2>{h2}</h2>
    </div>
  )
}
